import { FundingType } from '@app-types/funding';

import { LockedPlanValue } from '@helpers/plan-lock';

import { PlanRange, PlanSubTypeId, PlanTypeId } from '@constants/plan';
import { PLAY, TECHNOLOGY } from '@constants/provider';

import { EligibilityOptionType } from './eligibility';
import { Product } from './product';
import { GalliumOffreApi } from './renewal';

export enum MobilePlanProvenanceType {
    DEFAULT = 'default',
    CART = 'cart',
    OWNED = 'owned',
    URL = 'url',
}

export enum ObligationType {
    MONTHLY_12 = 'monthly12',
    MONTHLY_24 = 'monthly24',
    NONE = 'none',
}

export interface BasePlanType extends Product {
    obligation?: ObligationType;
    obligationLabel?: string;
    commercialRange?: PlanRange;
}

export interface MobilePlanType extends BasePlanType {
    dataEnvelope: string;
    subTypeId: PlanSubTypeId;
    dataSize?: number;
    fromAbroad?: string;
    fundings: FundingType[];
    gencode: string;
    hasDoubleSim: boolean;
    hasLowPrice: boolean;
    internationalCall?: string;
    isDarwin: boolean;
    price: number;
    isExcluPro: boolean;
    smsMms?: string;
    typeId: PlanTypeId;
    roamingEnvelope?: string;
    isOwned?: boolean;
    detailsDescription?: string;
    planFlag?: string;
    locked?: LockedPlanValue;
    maxConnections?: string;
    entityId?: string;
    isDefault?: boolean;
    hasSmartChangeEquivalent?: boolean;
    renewalDiscounts?: GalliumOffreApi[];
    hasRenewalDiscounts?: boolean;
    renewalLabelDataEnvelope?: string;
    obligation: ObligationType;
    obligationLabel: string;
}

export type FaiType = BasePlanType & {
    rentalFees: number;
    downRates: string;
    upRates: string;
    technology: TECHNOLOGY;
    play: PLAY;
    categoryType: string;
    rangeNg: string;
    commercialSeries: string;
    nuggets?: FaiTypeNugget[];
    speedWording?: string;
    hat?: string;
    options?: Array<FaiTypeOptions>;
    subtitle?: string;
    detailsUrl?: string;
    speedOption?: EligibilityOptionType;
    isDefault: boolean;
    range: string;
};

export type MobilePlanDetailWithProvenanceType = {
    origin: MobilePlanProvenanceType;
    plan: MobilePlanType | null;
};

export type CategoryListType = CategoryPlanType[];

export type CategoryPlanType = {
    id: string;
    name: string;
    description: string | null;
    code: string;
    subtitle: string;
    url: string;
    products: MobilePlanType[];
    _links: {
        detailCategory: {
            href: string;
        };
    };
};

export type FaiTypeNugget = {
    icon?: string;
    image?: string;
    label: string;
    description?: string;
    position?: number;
    showSpeed?: boolean;
};

export type FaiTypeOptions = {
    logo_url: string;
    logo_alt: string;
    label: string;
    position: number;
};

export interface FaiTypeWithEligibility extends FaiType {
    isEligible?: boolean;
}

export type CategoryCodeInfo = {
    range: string;
    rangeNg: string;
    commercialSeries: string;
    technology: TECHNOLOGY;
    shortDescription?: string;
};

export type OffersByCategoryCode = {
    [categoryCode: string]: CategoryCodeInfo[];
};

export type PlanType = FaiType | MobilePlanType;
